import * as types from './types';

/**
 * Builds the action to dispatch for fetching quote templates.
 * @param {object} payload
 * @param {number} payload.orgId - The id of the org to get the templates from.
 * @returns {object} - the action to dispatch.
 */
export const getQuoteTemplates = (payload) => {
  return {
    type: types.GET_QUOTE_TEMPLATES,
    payload,
  };
};
